import React, {useState, useRef} from "react";
import {ReadHebrewText} from "./misc";

// textsLists : list of paragraphs which are list of texts
// onSentenceChangeCallBack : receives the paragraph number and sentence number
const SpeakerButton = ({className, textsLists, onSwitchTextCallBack = null, pauseDuration = 10}) => {

    const [isSpeaking, setIsSpeaking] = useState(false);

    const textsList = useRef([]);
    const indexMapRef = useRef([]);
    const currentIndexRef = useRef(0);
    const pauseTimeoutRef = useRef(null);

    const flattenTextsLists = () => {
        textsList.current = [];
        indexMapRef.current = [];
        textsLists.forEach((group, i) => {
            group.forEach((phrase, j) => {
                textsList.current.push(phrase);
                indexMapRef.current.push([i, j]);
            });
        });
    };

    // Only used for advanced reading
    const onSwitchText = () => {
        console.log("change sentence")
        const [i, j] = indexMapRef.current[currentIndexRef.current];
        console.log(i,j)
        onSwitchTextCallBack?.(i, j);
        currentIndexRef.current += 1;
    }

    const stopSpeaking = () => {
        speechSynthesis.cancel();
        clearTimeout(pauseTimeoutRef.current);
        setIsSpeaking(false);
        currentIndexRef.current = 0;
        onSwitchTextCallBack?.(-1, -1);
    };

    // Main Function that enables/disables speaking
    const toggleSpeaking = () => {
        if (isSpeaking) {
            stopSpeaking();
        } else {
            flattenTextsLists();
            setIsSpeaking(true);
            currentIndexRef.current = 0;
            ReadHebrewText(textsList.current.map(t => t[3]), stopSpeaking, onSwitchText)
        }
    };

    return (
        <button
            onClick={toggleSpeaking}
            className={className + " speaker-button " + (isSpeaking ? "speaking" : "")}
        >
            🔊
        </button>
    );
};

export default SpeakerButton;


